
const digest = '3a739bff99c67464b4661dcb490bcbc7500648379ed5c45b50fef55ec98a8382';
const classes = {"wrapper":"_wrapper_8wfyf_1","input":"_input_8wfyf_5","error":"_error_8wfyf_23"};
const css = `._wrapper_8wfyf_1 {
  margin-bottom: 10px;
}

._input_8wfyf_5 {
  border: 1px solid #e2e5ed;
  min-height: 55px;
  font-family: Rubik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  border-right: 0;
  border-radius: 24.5px;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  padding: 16px 20px;
  color: #000;
  background-color: #fff;
}
._input_8wfyf_5:focus {
  box-shadow: 0 0 0 3px rgba(22, 101, 216, 0.15), inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-color: #1665d8;
  color: #000;
}
._input_8wfyf_5._error_8wfyf_23 {
  border-color: #d81616 !important;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  